/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Note_1_DescriptionInputs */

const en_homepage_features_note_1_description = /** @type {(inputs: Homepage_Features_Note_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't miss crucial studies just because you hate writing! 1 click = 1 note captured`)
};

const es_homepage_features_note_1_description = /** @type {(inputs: Homepage_Features_Note_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡No te pierdas estudios cruciales solo porque no te gusta escribir! 1 clic = 1 nota capturada`)
};

/**
* | output |
* | --- |
* | "Don't miss crucial studies just because you hate writing! 1 click = 1 note captured" |
*
* @param {Homepage_Features_Note_1_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_note_1_description = /** @type {((inputs?: Homepage_Features_Note_1_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Note_1_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_note_1_description(inputs)
	return en_homepage_features_note_1_description(inputs)
});